import { EDIT_TYPE } from '@constant'
import { get, set } from 'lodash'

import {
  StaticFormat,
  StaticLinkFormat,
  StaticMetaFormat,
  StaticObjectFormat,
} from './form-convert'
import { FieldFactory } from './type-field'

export function convertFieldsToHeader(fields) {
  let MAX_FIELD_SHOW_INIT = 5
  return fields.reduce((acc, field, index) => {
    if (field && (!field.visibility || field.visibility.browse)) {
      let value =
        field.type == 'reference'
          ? `${field.meta.reference.relationship}.${field.meta.reference.text}`
          : field['value'] || field['code']
      let type = field.type
      let format = null
      if (
        field.domain &&
        field.domain.domain_type == 'code-value' &&
        field.domain.metadata.items &&
        field.domain.metadata.items.length > 0
      ) {
        format = (value) => {
          let item = field.domain.metadata.items.find((x) => x.value == value)
          return item ? item.text : value
        }
      }
      acc.push({
        value,
        type,
        text: field['text'] || field['name'],
        sortable: false,
        filterable: false,
        hidden: index > MAX_FIELD_SHOW_INIT,
        format,
      })
    }
    return acc
  }, [])
}
export function convertFormToListField(model = {}, fields = [], type = 'read') {
  let results = []
  fields.forEach((field) => {
    if (field.visibility && !field.visibility[type]) return
    let temp_field = getFieldShow(field)
    if (temp_field)
      results.push({
        field,
        id: temp_field.key,
        value: temp_field.getValue(model) || temp_field.field.defaultValue(),
        typeShow: temp_field.typeShow,
      })
  })
  return results
}

export function convertFormToCompareField(
  fields = [],
  new_data = {},
  old_data = null
) {
  let results = []
  fields.forEach((field) => {
    let temps = [field]
    if (field.type == 'region-field') {
      temps = convertRegionFieldToMultiField(field)
    }
    temps.forEach((temp) => {
      let temp_field = getFieldShow(temp)
      if (!temp_field) {
        return
      }
      if (old_data) {
        if (temp_field.getValue(new_data) == temp_field.getValue(old_data))
          return
      } else {
        if (temp_field.getValue(new_data) == null) {
          return
        }
      }
      results.push({
        field: temp,
        id: temp_field.key,
        new_data: temp_field.getValue(new_data),
        type_show: temp_field.typeShow,
        old_data: temp_field.getValue(old_data || {}),
      })
    })
  })
  return results
}
function convertRegionFieldToMultiField(field) {
  let option = get(field, 'meta.field')
  let fields = []
  if (option.militaryOption != null) {
    let militaryOption = option.militaryOption
    fields.push({
      id: field.id + '_military',
      layer_id: field.layer_id,
      code: militaryOption.field || 'military_id',
      name: militaryOption.label || 'Quân khu',
      type: 'string',
      visibility: {
        browse: true,
        read: true,
        update: true,
        create: true,
      },
    })
  }
  if (option.provinceOption != null) {
    let provinceOption = option.provinceOption
    fields.push({
      id: field.id + '_province',
      layer_id: field.layer_id,
      code: provinceOption.field || 'province_id',
      name: provinceOption.label || 'Tỉnh/Thành phố',
      type: 'string',
      visibility: {
        browse: true,
        read: true,
        update: true,
        create: true,
      },
    })
  }
  if (option.districtOption != null) {
    let districtOption = option.districtOption
    fields.push({
      id: field.id + '_district',
      layer_id: field.layer_id,
      code: districtOption.field || 'district_id',
      name: districtOption.label || 'Huyện',
      type: 'string',
      visibility: {
        browse: true,
        read: true,
        update: true,
        create: true,
      },
    })
  }
  if (option.communeOption != null) {
    let communeOption = option.communeOption
    fields.push({
      id: field.id + '_commune',
      layer_id: field.layer_id,
      code: communeOption.field || 'commune_id',
      name: communeOption.label || 'Xã',
      type: 'string',
      visibility: {
        browse: true,
        read: true,
        update: true,
        create: true,
      },
    })
  }
  return fields
}
function getFieldShow(x) {
  if (x.type == 'region-field') {
    return new ShowField(x, StaticObjectFormat)
  } else if (x.field_meta) {
    return new ShowField(x, StaticMetaFormat)
  } else if (x.static) {
    return new ShowField(x, StaticFormat)
  }
  return new ShowField(x, StaticFormat)
}
function getFieldConvert(x) {
  if (x.type == 'region-field') {
    return new TypeField(x, StaticObjectFormat)
  } else if (x.code == 'doituong') {
    return new TypeField(x, StaticLinkFormat)
  } else if (x.code) {
    return new TypeField(x, StaticFormat)
  } else if (x.field_meta) {
    return new TypeField(x, StaticMetaFormat)
  }
}
export class DynamicForm {
  constructor(type = EDIT_TYPE.CREATE) {
    this._model = {}
    this.fields = []
    this.type = type
  }
  set fields(fields = []) {
    this._fields = fields
    this.field_convert = fields.reduce((acc, x) => {
      let temp = getFieldConvert(x)
      if (temp) {
        acc.push(temp)
      }
      return acc
    }, [])
    this.setDefaultValue()
  }
  get fields() {
    return this.field_convert
  }
  set model(model) {
    this._model = model || {}
  }
  get model() {
    return this._model
  }
  set type(type) {
    this._type = type || EDIT_TYPE.CREATE
    this.fieldsByType = this.field_convert.filter(
      (x) => x.visibility[this._type]
    )
  }
  get type() {
    return this._type
  }
  getValueForField(field) {
    return field.getValue(this._model)
  }
  getErrorValueForField(field, error) {
    return field.getValue(error)
  }
  setValueForField(field, value) {
    this._model = field.setValue(this._model, value)
  }
  setDefaultValue() {
    this.field_convert.forEach((field) => {
      this._model = field.setValue(
        this._model,
        field.getValue(this._model) || field.defaultValue()
      )
    })
  }
}
export class SimpleTypeField {
  constructor(field, format) {
    this.info = field
    this.field = FieldFactory.getField(field.type, field)
    this.format = format
  }
  get code() {
    return this.info.value || this.info.code || this.info.name || this.info.id
  }
  get key() {
    return this.info.value || this.info.code || this.info.id
  }
  get typeInput() {
    return this.field.typeInput
  }
  get typeShow() {
    return this.field.typeShow || 'text'
  }
  get meta() {
    return this.field.meta
  }
  getValue(model) {
    return this.format.getValue(model, this.code, this)
  }
  setValue(model, value) {
    return this.format.setValue(model, this.code, value, this)
  }
  defaultValue() {
    return this.field.defaultValue()
  }
}
export class TypeField extends SimpleTypeField {
  get required() {
    return this.info.required
  }
  get readonly() {
    return this.info.readonly
  }
  get visibility() {
    return this.info.visibility
  }
}

class ShowField extends TypeField {
  getValue(model) {
    return this.field.formatShow(this.format.getValue(model, this.code))
  }
}
